import MainHBS from "oc-commons/MainHBS.js";

/**
 * Zentraler Zugriff auf alle Handlebars-Templates dieses Moduls
 * require.context muss hier übergeben werden, um Webpack einen Zugriffspunkt auf dieses konkrete
 * Modul-Verzeichnis zu geben, damit zur Build-Zeit alle HBS-Files registriert werden können
 */
export default MainHBS(require.context(".", true),20,'oc-interaction');
